import fetch from '../../utils/fetch'

export function userGetCoupon(params) {
    return fetch({
        url: '/api/userCoupon/userGetCoupon',
        method: 'POST',
        data: params
    })
}
//预付券领券
export function userGetpaymentCoupon(params) {
    return fetch({
        url: '/api/userCoupon/userGetYfCoupon',
        method: 'POST',
        data: params
    })
}

export function userBuyCoupon(params) {
    return fetch({
        url: '/api/userCoupon/wxUserBuyCoupon',
        method: 'POST',
        data: params
    })
}


